import React from 'react';

// Summary cards above a Historial table (styles in pages/SalesFormPage.css).
// `cards` is a list of [label, number].
export default function HistorySummary({ cards }) {
  return (
    <div className="history-summary">
      {cards.map(([label, value]) => (
        <div key={label} className="history-summary-card">
          <div className="history-summary-label">{label}</div>
          <div className="history-summary-value">{value.toLocaleString('es-EC')}</div>
        </div>
      ))}
    </div>
  );
}
